import $ from "jquery";
import "slick-carousel-latest";
import "./js/header";
import "./js/modal";

import "./js/slick";
import "./js/page";
import "./js/map";
import "./js/misc";

import "./js/lettergrootte";

jQuery(function () {
  console.log("Ready");

  // Smooth scrolling to anchor # ///////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $('a[href*="#"]:not([href="#"]):not(.sf-dump-toggle)').on(
    "click",
    function () {
      if (
        location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html,body").animate(
            {
              scrollTop: target.offset().top,
            },
            1000
          );

          target.trigger("focus");
          return false;
        }
      }
    }
  );
  if (window.location.hash) {
    // Smoothly scroll to the target anchor
    $("html, body").animate(
      {
        scrollTop: $(window.location.hash).offset().top,
      },
      1000
    );
  }
  // Smooth scrolling to anchor # ///////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END
});
// Document.ready END
///////////////////////////////////////////////////////////////////////////////
